import {
  DSButton,
  DSCheckbox,
  DSLinkButton,
} from "@components/design-system/molecules";
import { faCheck, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

const ConsentStep = ({ onContinue, onBack, setCurrentStep }) => {
  const [rememberDecision, setRememberDecision] = useState(false);

  const handleContinue = () => {
    onContinue(rememberDecision);
  };

  return (
    <>
      <div className="mb-6">
        <div className="flex items-center justify-center mb-4">
          <FontAwesomeIcon
            icon={faPhone}
            className="text-green-400 text-2xl"
          />
        </div>

        <h3 className="text-lg font-semibold text-primary mb-4 text-center">
          Call Recording Consent
        </h3>

        <div className="bg-warning-subtle border border-warning-subtle rounded-lg p-4 mb-6">
          <div className="text-sm text-yellow-800 dark:text-yellow-200">
            <p className="mb-3">
              It is <strong>your responsibility</strong> to inform
              your client that this call is being monitored and
              recorded.
            </p>
            <p>
              By proceeding, you acknowledge that you will obtain any
              necessary consent from your client before starting the
              call.
            </p>
            <p>
              Alternatively,{" "}
              <strong>
                you can enable the Automatic Verbal Warnings
              </strong>{" "}
              in the{" "}
              <DSLinkButton
                onClick={() => setCurrentStep("settings")}
                title="Scribephone Settings"
              >
                Scribephone settings
              </DSLinkButton>
              .
            </p>
          </div>
        </div>

        <div className="flex items-start space-x-3 mb-6">
          <label
            htmlFor="remember-decision"
            className="flex items-center cursor-pointer select-none"
          >
            <span className="relative">
              <DSCheckbox
                id="remember-decision"
                dataTestId="scribephone-remember-decision-checkbox"
                checked={rememberDecision}
                onChange={(e) =>
                  setRememberDecision(e.target.checked)
                }
              />
            </span>
            <span className="ml-3 text-sm text-primary">
              Remember my decision for future calls
            </span>
          </label>
        </div>
      </div>

      <div className="flex gap-3 justify-center">
        <DSButton onClick={onBack} variant="secondary" size="md">
          Back
        </DSButton>

        <DSButton
          onClick={handleContinue}
          variant="primary"
          leadingIcon={faCheck}
          dataTestId="scribephone-i-understand-button"
        >
          I Understand
        </DSButton>
      </div>
    </>
  );
};

export default ConsentStep;
